(function () {
  'use strict';
  if (window.AfRoomLibrary) return;
  var memory = {rooms:[], selected:'', nextNumber:1}, persistent = true, opening = null;
  var queue = Promise.resolve();
  function database() {
    if (opening) return opening;
    opening = new Promise(function (resolve) {
      var request, done = false;
      function finish(db) { if (done) { if (db) db.close(); return; } done = true; clearTimeout(timer); if (!db) persistent = false; resolve(db); }
      // La première ouverture peut dépasser deux secondes sur un navigateur chargé.
      // Garder la bibliothèque persistante disponible avant de proposer le repli en mémoire.
      var timer = setTimeout(function () { finish(null); }, 10000);
      try {
        request = indexedDB.open('affichely-rooms',1);
        request.onupgradeneeded = function () {
          var db = request.result;
          if (!db.objectStoreNames.contains('rooms')) db.createObjectStore('rooms',{keyPath:'id'});
          if (!db.objectStoreNames.contains('settings')) db.createObjectStore('settings');
        };
        request.onsuccess = function () {
          var db = request.result;
          db.onversionchange = function () { db.close(); opening = null; };
          finish(db);
        };
        request.onerror = request.onblocked = function () { finish(null); };
      } catch (_) { finish(null); }
    });
    return opening;
  }
  function valid(room) {
    return room && typeof room.id === 'string' && room.blob instanceof Blob
      && room.blob.type === 'image/jpeg' && room.width >= 100 && room.width <= 1600
      && room.height >= 100 && room.height <= 1600;
  }
  function snapshot(state) {
    return {rooms:state.rooms.slice().sort(function(a,b){return b.usedAt-a.usedAt;}),selected:state.selected,persistent:persistent};
  }
  function decode(room) {
    if (!room || !(room.bytes instanceof ArrayBuffer)) return room;
    return Object.assign({},room,{blob:new Blob([room.bytes],{type:'image/jpeg'}),
      thumb:room.thumbBytes?new Blob([room.thumbBytes],{type:'image/jpeg'}):null});
  }
  function encode(room) {
    var stored=Object.assign({},room);delete stored.blob;delete stored.thumb;return stored;
  }
  function operate(change) {
    var task = queue.then(async function () {
      var db = persistent ? await database() : null, result, candidate;
      if (db) {
        try {
          await new Promise(function (resolve,reject) {
            var tx = db.transaction(['rooms','settings'],change?'readwrite':'readonly');
            var rooms = tx.objectStore('rooms'), settings = tx.objectStore('settings');
            var records = rooms.getAll(), meta = settings.get('state'), left = 2;
            function read() {
              if (--left) return;
              var old = records.result, decoded=old.map(decode), config = meta.result || {};
              candidate = {rooms:decoded.filter(valid),selected:config.selected || '',nextNumber:config.nextNumber || 1};
              if (!change) return;
              result = change(candidate);
              old.forEach(function (r) { if (!candidate.rooms.some(function(n){return n.id===r.id;})) rooms.delete(r.id); });
              candidate.rooms.forEach(function (r) { if (decoded.indexOf(r) < 0) rooms.put(encode(r)); });
              settings.put({selected:candidate.selected,nextNumber:candidate.nextNumber},'state');
            }
            records.onsuccess = meta.onsuccess = read;
            tx.oncomplete = resolve;
            tx.onabort = tx.onerror = function () { reject(tx.error || new Error('storage')); };
          });
          memory = candidate;
          return {value:result,library:snapshot(memory)};
        } catch (_) { persistent = false; }
      }
      if (candidate) memory = candidate;
      else if (change) result = change(memory);
      return {value:result,library:snapshot(memory)};
    });
    queue = task.catch(function () {});
    return task;
  }
  window.AfRoomLibrary = {
    read:function () { return operate(null).then(function(r){return r.library;}); },
    add:async function (photo) {
      photo=Object.assign({},photo,{bytes:await photo.blob.arrayBuffer(),thumbBytes:photo.thumb?await photo.thumb.arrayBuffer():null});
      return operate(function (s) {
        var room = s.rooms.find(function(r){return r.id===photo.id;});
        if (!room) room = Object.assign({},photo,{number:s.nextNumber++,name:'',createdAt:Date.now()});
        room = Object.assign({},room,{usedAt:Date.now()});
        s.rooms = s.rooms.filter(function(r){return r.id!==room.id;}); s.rooms.unshift(room);
        var bytes = 0;
        s.rooms = s.rooms.sort(function(a,b){return b.usedAt-a.usedAt;}).filter(function(r,i){bytes+=r.blob.size+(r.thumb?r.thumb.size:0);return i<12 && bytes<=24*1024*1024;});
        s.selected = room.id;
        return room;
      });
    },
    update:function (id,patch) {
      return operate(function (s) {
        var i = s.rooms.findIndex(function(r){return r.id===id;});
        if (i < 0) return null;
        s.rooms[i] = Object.assign({},s.rooms[i],patch,{id:id});
        return s.rooms[i];
      });
    },
    select:function (id) {
      return operate(function (s) {
        var i = s.rooms.findIndex(function(r){return r.id===id;});
        if (i < 0) return null;
        s.selected = id; s.rooms[i] = Object.assign({},s.rooms[i],{usedAt:Date.now()});
        return s.rooms[i];
      });
    },
    remove:function (id) {
      return operate(function (s) {
        s.rooms = s.rooms.filter(function(r){return r.id!==id;});
        if (s.selected===id) s.selected='';
      });
    }
  };
})();
